import { LcarsPanel } from '../components/layout/LcarsPanel';

export function Queue() {
  return (
    <div class="page">
      <LcarsPanel color="var(--lilac)" title="Queue">
        <div style={{ padding: '24px 16px', fontFamily: 'var(--mono)', fontSize: '12px', color: 'var(--text-dim)' }}>
          Coming soon — Publishing queue with scheduling and approval workflow.
        </div>
      </LcarsPanel>
    </div>
  );
}
